/**
 * @description Socket Store Module
 * @author Abdul Aziz
 */
import Vue from 'vue';
import http from '../../util/axios';
import i18n from '../../i18n';
import config from '../../config';
import { ConnectionStatus } from '../../util/common';
import io from "socket.io-client";

export default {
    namespaced: true,
    state: {
        socketId: null,
        newMsgFlag: false,
        socket: null
    },
    mutations: {
        SET_SOCKET_ID: (state, payload) => {
            state.socketId = payload;
        },
        SET_NEW_MSG_FLAG: (state, payload) => {
            state.newMsgFlag = payload
        },
        SET_SOCKET: (state, payload) => {
            state.socket = payload
        }
    },
    actions: {
        SET_SOCKET_ID ( { commit }, payload) {    
            commit('SET_SOCKET_ID', payload)
        },
        SET_NEW_MSG_FLAG( { commit }, payload) {
            commit('SET_NEW_MSG_FLAG', payload)
        },
        SET_SOCKET( { commit }, payload ) {
            commit('SET_SOCKET', payload)
        }
    },
    getters: {
        getSocketId: state => state.socketId,
        getNewMsgFlag: state => state.newMsgFlag
    },

}



// WEBPACK FOOTER //
// ./src/store/modules/socket.js